// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InstanceRole } from "./InstanceRole";
import {
  InstanceRoleFromJSON,
  InstanceRoleFromJSONTyped,
  InstanceRoleToJSON,
  InstanceRoleToJSONTyped,
} from "./InstanceRole";

/**
 *
 * @export
 * @interface InstanceUserRead
 */
export interface InstanceUserRead {
  /**
   *
   */
  userId: string;
  /**
   *
   */
  role: InstanceRole;
}

/**
 * Check if a given object implements the InstanceUserRead interface.
 */
export function instanceOfInstanceUserRead(value: object): value is InstanceUserRead {
  if (
    (!("userId" in (value as Record<string, any>)) &&
      !("user_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["userId"] === undefined &&
      (value as Record<string, any>)["user_id"] === undefined)
  )
    return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  return true;
}

export function InstanceUserReadFromJSON(json: any): InstanceUserRead {
  return InstanceUserReadFromJSONTyped(json, false);
}

export function InstanceUserReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InstanceUserRead {
  if (json == null) {
    return json;
  }
  return {
    userId: json["user_id"],
    role: InstanceRoleFromJSON(json["role"]),
  };
}

export function InstanceUserReadToJSON(json: any): InstanceUserRead {
  return InstanceUserReadToJSONTyped(json, false);
}

export function InstanceUserReadToJSONTyped(
  value?: InstanceUserRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user_id: value["userId"],
    role: InstanceRoleToJSON(value["role"]),
  };
}
